// extracted by mini-css-extract-plugin
export var displayNone = "_u5-6";
export var imgContainer = "_u5-2";
export var overflowHidden = "_u5-3";
export var productInfoCardButtonContainer = "_u5-5";
export var productTitleText = "_u5-4";
export var rightArrow = "_u5-1";
export var rightArrowContainer = "_u5-0";